<template>
  <template v-if="newReviewDisplay">
    <ReviewsListSkeleton v-if="isPending" :limit />

    <ul v-else-if="reviews?.length" class="space-y-12">
      <li
        v-for="(review, index) in reviews"
        :key="review.id"
        class="overflow-hidden"
      >
        <UserComment :position="index" v-bind="review" />
      </li>
    </ul>
  </template>

  <template v-else>
    <ReviewsListSkeleton v-if="isPending" :limit />

    <RevList v-else-if="reviews?.length" :has-external-borders="false">
      <RevListItemStatic
        v-for="(review, index) in reviews"
        :key="review.id"
        main-area-classNames="overflow-hidden"
      >
        <template #label>
          <UserComment :position="index" v-bind="review" />
        </template>
      </RevListItemStatic>
    </RevList>
  </template>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { Review } from '@backmarket/http-api/src/api-specs-reviews/types/review'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { RevList } from '@ds/components/List'
import { RevListItemStatic } from '@ds/components/ListItemStatic'

import { REVIEWS_LIST_DEFAULT_LENGTH } from '../../constants'
import UserComment from '../UserComment/UserComment.vue'

import ReviewsListSkeleton from './ReviewsListSkeleton.vue'

const experiments = useExperiments()

type ReviewsList = {
  reviews: Review[]
  isPending?: boolean
  limit?: number
}

withDefaults(defineProps<ReviewsList>(), {
  limit: REVIEWS_LIST_DEFAULT_LENGTH,
  isPending: false,
})

const newReviewDisplay = computed(() => {
  return experiments['experiment.reviewDisplay'] === 'newReviewDisplay'
})
</script>
